import { lazy } from 'react';

export const PlayerWagerLimitsForm = lazy(
  () => import('./PlayerWagerLimitsForm'),
);
